export const inboxPages = {
  inbox: () => import('./pages/InboxPage'),
};
export { TaskQueries } from './components/TaskQueries';
